{
  "id": "skadi",
  "pantheon": "norse",
  "name": {
    "pt-BR": "Skadi",
    "en": "Skadi"
  },
  "icon": "gods/skadi",
  "portrait": "gods/skadi-portrait",
  "age": "heroic",
  "freeUnitsOnAgeUp": {
    "frost-giant": 1
  },
  "unlocks": ["frost-giant", "arctic-winds", "rime", "huntress-axe", "winter-harvest"],
  "powers": ["frost"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Odin, Thor. Focus: economy and Throwing Axemen. Age tech HeroicAgeSkadi."
  },
  "fieldMeta": {
    "freeUnitsOnAgeUp": {
      "source": "Game files 19.17020 (techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "HeroicAgeSkadi: CreateUnit frost-giant quantity 1, generator AbstractTemple (spawns at a Temple)."
    }
  }
}
